import { Component, ElementRef, Inject, Renderer2, ViewChild } from '@angular/core';
import { FormControl, FormGroup, FormBuilder } from '@angular/forms';
import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepickerIntl } from '@angular/material/datepicker';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { CustomSnackbarService } from 'src/app/components/custom-notification/custom-notification.component';
import { LocalBusinessManagerService } from 'src/app/service/local-business-manager.service';
import { ProductListingService } from 'src/app/service/product-listing.service';
import { RegisterService } from 'src/app/service/register.service';
import { UtilityService } from 'src/app/service/utility.service';
import { ResponseStatus } from 'src/enum/responseEnum';

@Component({
  selector: 'app-local-business-manager',
  templateUrl: './local-business-manager.component.html',
  styleUrls: ['./local-business-manager.component.css']
})
export class LocalBusinessManagerComponent {
  @ViewChild('searchInput') searchInput: any;
  title = 'Product Business <span>Listing</span>';
  title1 = 'Kraft Designs';
  title2 = 'Add new Product';
  title3 = 'Edit Product';
  class1 = "profile-banner"
  productDetailsTitle = "Product details"
  currentPage: number = 1;
  pageLimit: number = 5;
  totalRecords: number = 1;
  products: any[] = [];
  loading: boolean = true;
  showAddProductCard: boolean = false;
  showEditProductCard: number = 0;
  addProductForm: any = FormGroup;
  shopifyLink: string = "";
  lastSynched: string = "";
  description: string = "";
  showDescription: boolean = false;
  showDeleteProductModel: number = 0;
  userBusinessDetails: any = [];
  searchProduct: string = "";
  productDetails: any = {
    loading: false,
    response: null,
    error: ''
  }
  selectedOption: string = "";
  filteredOptions: any[] = [];
  searchBusiness: string = "";
  branchesList: any = {
    loading: false,
    response: null,
    error: ''
  }
  showDiv: number | null = null;
  selectedBranch: number | null = null;
  showDetails: boolean = false;
  addToFavLoader: number | null = null;
  filterForm: any = FormGroup;
  defaultFilterValues: any = {
    productTypeId: [""],
    businessName: [""],
    dateFrom : [""],
    dateTo : [""],
    validationStatusId: [""],
    productCategoryId: [""],
  }

  categoryList: any = {
    loading: false,
    response: null,
    error: ''
  };
  productTypes: any = {
    loading: false,
    response: null,
    error: ''
  };
  businessList: any = {
    loading: false,
    response: null,
    error: ''
  };
  productStatus: any = {
    loading: false,
    response: null,
    error: ''
  };
  approveLoader: boolean = false;
  rejectLoader: boolean = false;
  approvedOnly:boolean = false;

  statusLoading: number = 0;

  toggleErrorPopup: boolean = false;
  toggleErrorMsg = ''

  modalOption!: NgbModalOptions;

  constructor(private productListingService: LocalBusinessManagerService, private customSnackbarService: CustomSnackbarService,
    private register: RegisterService, private router: Router, private fb: FormBuilder, private activatedroute: ActivatedRoute,
    private utility : UtilityService,     private elementRef: ElementRef,private renderer: Renderer2,
    private _adapter: DateAdapter<any>,
    private _intl: MatDatepickerIntl,
    @Inject(MAT_DATE_LOCALE) private _locale: string,) {
      this._adapter.setLocale('in');
    this.approvedOnly = this.activatedroute.snapshot.data['approvedOnly'];

    this.modalOption = {
      backdrop: 'static',
      keyboard: false,
      centered: false,
      windowClass: 'ToggleCustomClass'
    }
    // this.addProductForm = new FormGroup({
    //   productName: new FormControl({ value: "", disabled: false }, []),
    //   category: new FormControl({ value: "", disabled: false }, []),
    //   subCategory: new FormControl({ value: "", disabled: false }, []),
    //   description: new FormControl({ value: "", disabled: false }, []),
    //   shopifyLink: new FormControl({ value: "", disabled: false }, []),
    //   weight: new FormControl(""),
    //   weightUnit: new FormControl({ value: "", disabled: false }, []),
    //   delDistance: new FormControl({ value: "", disabled: false }, []),
    //   productTypeId: new FormControl({ value: "", disabled: false }, []),
    //   packingTypeId: new FormControl({ value: "", disabled: false }, []),
    //   mediaList: new FormControl({ value: "", disabled: false }, []), //array

    //   variantList
    //   price: new FormControl({ value: "", disabled: false }, []),
    //   discountedPrice: new FormControl({ value: "", disabled: false }, []),
    //   quantity: new FormControl({ value: "", disabled: false }, []),
    //   stockStatusId: new FormControl({ value: "", disabled: false }, []),
    //   statusId: new FormControl({ value: "", disabled: false }, []),
    //   sku: new FormControl({ value: "", disabled: false }, []),
    //   variantOption1: new FormControl({ value: "", disabled: false }, []),
    //   variantOption2: new FormControl({ value: "", disabled: false }, []),
    //   variantOption3: new FormControl({ value: "", disabled: false }, []),
    // })
    this.filterForm = this.fb.group(this.defaultFilterValues);
    if(this.approvedOnly){
      this.filterForm.get("validationStatusId").setValue(2)  // for approved only right now we have status id as 14 it may change in future
      this.title = 'Approved <span>Business Listing</span>'
    }
    this.getProductCategories()
    this.getProductTypes()
    // this.getProductStatus()
    this.getProductApproval();
  }

  onSearchInput(event: Event): any {
    this.searchBusiness = (event.target as HTMLInputElement).value.toLowerCase();
    this.getBusinessList(this.searchBusiness)
  }

  handleStatus(event:any, product:any){
    if(this.statusLoading){
      return
    }
    this.statusLoading = product.productId;
    event.preventDefault()
    event.stopImmediatePropagation()
    this.productListingService.statusUpdate(product.productId,product.productStatus === "Active"? "InActive" : "Active" ).then((res: any) => {
      if(res.data.status === 'SUCCESS') {
        this.getProductList();
      }
      else {
        this.toggleErrorPopup = true;
       this.toggleErrorMsg = res.data.desc;
      }
    }).catch((err: any) => {
      this.statusLoading = 0
    })
  }

  showStatus(product:any){
    return product?.productStatus === 'Active' ? true : false
  }
  onSelectOpenChange(isOpen: boolean): any {
    if (isOpen) {
      // Reset filtered options when the dropdown is opened
      this.filteredOptions = this.businessList.response;
    }
  }
  getProductApproval(){
    this.productStatus = {
      ...this.productStatus,
      loading: true,
      error: ''
    }
    this.productListingService.getProductApproval().then((res: any) => {
      this.productStatus = {
        ...this.productStatus,
        loading: false,
        response: res.data.data,
      }
    }).catch((err: any) => {
      this.productStatus = {
        ...this.productStatus,
        loading: false,
        response: null,
        error: err.response.statusText
      }
    })
  }
  getProductCategories() {
    this.categoryList = {
      ...this.categoryList,
      loading: true,
      error: ''
    }
    this.productListingService.getProductCategories().then((res: any) => {
      this.categoryList = {
        ...this.categoryList,
        loading: false,
        response: res.data.data,
      }
    }).catch((err: any) => {
      this.categoryList = {
        ...this.categoryList,
        loading: false,
        response: null,
        error: err.response.statusText
      }
    })
  }

  handleFilter() {
    this.searchProduct = "";
    this.currentPage = 1;
    this.getProductList()
  }

  getProductTypes() {
    this.productTypes = {
      ...this.productTypes,
      loading: true,
      error: ''
    }
    this.productListingService.getProductTypes().then((res: any) => {
      this.productTypes = {
        ...this.productTypes,
        loading: false,
        response: res.data.data,
      }
    }).catch((err: any) => {
      this.productTypes = {
        ...this.productTypes,
        loading: false,
        response: null,
        error: err.response.statusText
      }
    })
  }
  getBusinessList(search: string) {
    this.businessList = {
      ...this.businessList,
      loading: true,
      error: ''
    }
    const params = {
      type: "LOCAL_BUSINESS",
      search
    }
    this.productListingService.getBusinessList(params).then((res: any) => {
      this.businessList = {
        ...this.businessList,
        loading: false,
        response: res.data.records,
      }
      this.filteredOptions = res.data.records
    }).catch((err: any) => {
      this.businessList = {
        ...this.businessList,
        loading: false,
        response: null,
        error: err.response.statusText
      }
      this.filteredOptions = []
    })
  }

  getProductStatus() {
    this.productStatus = {
      ...this.productStatus,
      loading: true,
      error: ''
    }
    this.productListingService.getProductStatus().then((res: any) => {
      this.productStatus = {
        ...this.productStatus,
        loading: false,
        response: res.data.data,
      }
    }).catch((err: any) => {
      this.productStatus = {
        ...this.productStatus,
        loading: false,
        response: null,
        error: err.response.statusText
      }
    })
  }
  resetFilter() {
    this.filterForm.get("productTypeId").setValue("");
    this.filterForm.get("businessName").setValue("");
    this.filterForm.get("dateFrom").setValue("");
    this.filterForm.get("dateTo").setValue("");
    this.filterForm.get("productCategoryId").setValue("");
    if(this.approvedOnly){
      this.filterForm.get("validationStatusId").setValue(2);
    } else {
      this.filterForm.get("validationStatusId").setValue("");
    }

    if (this.searchInput) {
      this.searchInput.nativeElement.value = '';
      this.getBusinessList(this.searchInput)
    }
    this.getProductList();
    this.currentPage = 1;
    this.searchProduct = "";
  }


  ngOnInit() {
    this.getProductList()
    this.getUserDetails()
    // this.getAllAvailableBranches()
  }

  onSelectionChange(event: any) {
    this.currentPage = 1;
    this.searchProduct = '';
    this.selectedBranch = event.value;
    this.getProductList()

  }
  onPageChange(page: any) {
    this.currentPage = page;
    this.getProductList();
  }

  resetListing() {
    this.showAddProductCard = false;
    console.log('here')
    this.currentPage = 1;
    this.getProductList();
  }

  resetEditListing() {
    this.showEditProductCard = 0;
    console.log('here')
    this.getProductList();
  }
  onPageSizeChange(page: any) {
    this.pageLimit = page;
    this.currentPage = 1;
    this.getProductList();
  }
  handleProductApprove(id: number) {
    if(this.approveLoader || this.rejectLoader){
      return
    }
    this.approveLoader = true;
    this.productListingService.approveProduct(id).then((d: any) => {
      this.getProductList();
      this.showDetails = false;
      this.approveLoader = false;
      this.customSnackbarService.openCustomSnackbar(d.data.desc, 30000);
    }).catch((e) => {
      this.approveLoader = false;
      this.customSnackbarService.openCustomSnackbar("Unable to update, please try later.", 30000, true);
    })
  }

  handleProductReject(id: number) {
    if(this.approveLoader || this.rejectLoader){
      return
    }
    this.rejectLoader = true;
    this.productListingService.rejectProduct(id).then((r: any) => {
      this.getProductList();
      this.showDetails = false;
      this.rejectLoader = false;
      this.customSnackbarService.openCustomSnackbar(r.data.desc, 30000);
    }).catch((e) => {
      this.rejectLoader = false;
      this.customSnackbarService.openCustomSnackbar("Unable to update, please try later.", 30000, true);
    })
  }
  // getAllAvailableBranches() {
  //   this.branchesList = {
  //     ...this.branchesList,
  //     loading: true,
  //     error: ''
  //   }
  //   this.productListingService.getAvailableBranch().then((res: any) => {
  //     this.branchesList = {
  //       ...this.branchesList,
  //       loading: false,
  //       response: res.data.data,
  //     }
  //   }).catch((err: any) => {
  //     this.branchesList = {
  //       ...this.branchesList,
  //       loading: false,
  //       response: null,
  //       error: err.response.statusText
  //     }
  //   })
  // }


  getUserDetails() {
    this.loading = true;
    this.register.fetchUserDetails().then((res) => {
      if (res.status = ResponseStatus.SUCCESS) {
        this.userBusinessDetails = res.data;
        this.loading = false;
      }
    })
  }
  handleProductDelete() {
    if (this.showDeleteProductModel) {
      this.productListingService.deleteProduct(this.showDeleteProductModel).then(() => {
        this.currentPage = 1;
        this.getProductList();
        this.showDeleteProductModel = 0;
        this.customSnackbarService.openCustomSnackbar('The product has been deleted successfully.', 30000);
      })
    }
  }

  showProductDescription(des: string) {
    this.description = des;
    this.showDescription = true;
  }


  searchProductOnChange(event: any) {
    // if (value.target.value) {
    //   this.currentPage = 1;
    //   this.searchProduct = value.target.value;
    // }
    // else {
    //   this.searchProduct = "";
    // }

    // this.getProductList();

    const val = event.target.value;
    this.currentPage = 1;
    this.searchProduct = val;

    this.getProductList();
  }

  clearSearch() {
    this.searchProduct = '';
    this.getProductList();
  }

  addProductToFavorites(productVariantId: number, type: number) {
    if (this.addToFavLoader != null) {
      return
    }
    let favType = type == 0 ? 1 : 0
    this.addToFavLoader = productVariantId;
    this.productListingService.addProductToFavorites(productVariantId, favType).then((res: any) => {
      this.getProductList();
      if (res.data.desc) {
        this.customSnackbarService.openCustomSnackbar(res.data.desc, 30000, true);
        this.addToFavLoader = null;

      }
    }).catch((err: any) => {
      this.addToFavLoader = null;

    })
  }


  getProductList() {
    const x: any = {
      ...(this.filterForm.value?.businessName && this.filterForm.value?.businessName.length > 0 ? { businessNameIn: this.filterForm.value?.businessName } : {}),
      ...(this.filterForm.value?.productCategoryId && this.filterForm.value?.productCategoryId.length > 0 ? { productCategoryIdIn: this.filterForm.value?.productCategoryId } : {}),
      ...(this.filterForm.value?.validationStatusId && this.filterForm.value?.validationStatusId.length > 0 ? { validationStatusIdIn: this.filterForm.value?.validationStatusId } : {}),
      ...(this.filterForm.value.dateFrom
        ? { dateFromGrEq: this.utility.dateFormatter(this.filterForm.value.dateFrom) }
        : {}),
      ...(this.filterForm.value.dateTo
        ? { dateToLsEq: this.utility.dateFormatter(this.filterForm.value.dateTo) }
        : {}),
     }

    this.productListingService.getProductListing(this.searchProduct, this.currentPage, this.pageLimit, this.selectedBranch, x).then((res: any) => {
      this.products = res.data.records;
      this.lastSynched = res.data.lastSynched ?? "";
      this.shopifyLink = res.data.shopifyStoreLink ?? "";
      this.totalRecords = res.data?.totalRecords;
      this.loading = false;
      this.addToFavLoader = null;
      this.statusLoading = 0;
      // this.currentPage = 1;
    }).catch((err: any) => {
      this.loading = false;
      this.addToFavLoader = null;
      this.products = [];
    })
  }

  showProductDetails(id: number) {
    this.showDetails = true;
    this.productDetails = {
      ...this.productDetails,
      loading: true,
      error: ''
    }
    this.productListingService.getProductById(id).then((res: any) => {
      this.productDetails = {
        ...this.productDetails,
        loading: false,
        response: res.data.data,
      }
    }).catch((err: any) => {
      this.productDetails = {
        ...this.productDetails,
        loading: false,
        response: null,
        error: err.response.statusText
      }
      console.log(this.productDetails, 'ddddd')
    })
  }


  getProductShortDescription(des: any) {
    return false
    if (des && des.length > 40) {
      return true;
    }
    else {
      return false;
    }
  }
  selectedAvilableBranchesToShow(data: any[]) {
    return data.map((l: any) => `${l.name}`)
    return data.map((l: any) => `${l.branchName}, ${l.address}, ${l.city}, ${l.state}, ${l.pincode}`).join(',')
  }
  handleAddProduct(status: boolean) {
    this.showAddProductCard = status;
  }
  handleEditProduct(status: number) {
    this.showEditProductCard = status;
  }

  openDiv(event: any, index: number) {
    // event.preventDefault()
    event.stopImmediatePropagation();
    if (this.showDiv === null) {
      this.showDiv = index;

    } else {
      this.showDiv = null;
    }
  }
  closeDiv() {
    if (this.showDiv !== null) {
      this.showDiv = null;

    }
  }


  createNewProduct() { }

  preview : number = 0;
  previewImg : string = '';
  onPreview(url : string,value : number) : void {
    this.preview = value;
    this.previewImg = url;
      const parentElement = this.elementRef.nativeElement.querySelector('.addpro');
      if (parentElement) {
        const childElement = parentElement.querySelector('.modal-content');
        if (childElement) {
          if(value){
            this.renderer.addClass(childElement, 'fifty');
          }else{
            this.renderer.removeClass(childElement, 'fifty');
          }
        }
      }
  }
  setwidth(event : any){
    const imgElement = event.target as HTMLImageElement;
    imgElement.src = 'assets/images/upload-img.svg';
    imgElement.style.width = '50px';
    const parentDiv = imgElement.parentElement;
    if(parentDiv){
      parentDiv.classList.remove("img-div-remove");
      parentDiv.classList.add("img-div");
    }

  }
  categoryChange(event: any, catId: any) {
    if (event.isUserInput) {
      this.filterForm.patchValue({
        productCategoryId: catId
      });
      console.log('catId', catId);
    }
  }



  hideModel() {
    this.toggleErrorPopup = false;
    this.statusLoading = 0
  }
}
